import React, {useRef} from 'react';
import {Field} from 'formik';
import classnames from 'classnames';
import ImagePreview from '../ImagePreview';
import file from '../../assets/file_present-24px.svg';
import ok from '../../assets/check-black.svg';
import styles from './styles.module.scss';

const UploadButton = ({
                        buttonLabel,
                        customButtonLabel,
                        customButtonUploadContainer,
                        iconSrc,
                        fieldId,
                        selectedFile,
                        handleChange,
                        field,
                        form,
                        ...rest
                      }) => ({openModal}) => {
  const handleSelect = evt => {
    Promise.resolve()
      .then(() => handleChange(field, form)(evt))
      .then(() => openModal());
  };

  return (
    <label className={classnames(styles.uploadContainer, customButtonUploadContainer)}>
      <div className={classnames(styles.uploadButton, customButtonLabel)}>
        <img src={iconSrc} alt="file" className={styles.icon}/>
        <div>{buttonLabel}</div>
      </div>
      <input
        id={fieldId}
        type="file"
        className={styles.input}
        ref={selectedFile}
        onChange={handleSelect}
        {...rest}
      />
    </label>
  );
};

const FieldImageUpload = ({
                            fieldId,
                            label,
                            labelUploaded,
                            icon = file,
                            customButtonLabel,
                            fileUploaded,
                            onFileSelected,
                            formInitialValues,
                            closeParentModal,
                            formFields,
                            ...rest
                          }) => {
  const selectedFile = useRef(null);
  const buttonLabel = fileUploaded ? labelUploaded : label;
  const iconSrc = fileUploaded ? ok : icon;

  const handleChange = (field, form) => event => {
    const [selected] = selectedFile.current.files;
    form.setFieldValue(field.name, selected);
  };

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({field, form}) => (
        <ImagePreview
          id={`2-${fieldId}`}
          Button={UploadButton({
            buttonLabel,
            customButtonLabel,
            iconSrc,
            fieldId,
            selectedFile,
            handleChange,
            field,
            form,
            ...rest
          })}
          formFields={formFields}
          image={field.value}
          formInitialValues={formInitialValues}
          onConfirm={onFileSelected}
          closeParentModal={closeParentModal}
        />
      )}
    </Field>
  );
};

export default FieldImageUpload;